export class ResetStates {
  public static readonly type = '[Group] ResetStates';
}
